export enum ENUM_MS_COMAPNY_POLICIES_STATUS {
  PENDING = "pending",
  ACKNOWLEDGED = "acknowledged",
  OVERDUE = "overdue",
}

export enum ENUM_COMAPNY_POLICIES_STATUS {
  DRAFT = "draft",
  PUBLISHED = "published",
  WITHDRAWN = "withdrawn",
}

export enum ENUM_COMPANY_POLICY_VIEWED_STATUS {
  NOT_VIEWED = "Not Viewed",
  VIEWED = "Viewed",
}
